import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import { ExternalLink } from '@infl-ts/ui-advocate-components';
import { extension } from '@infl-ts/util-url';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { styled, Typography } from '@mui/material';
import { absurd, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledLink = styled(ExternalLink)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & svg.openIcon {\n    display: none;\n  }\n  &:hover svg.openIcon {\n    display: block;\n  }\n"])));

var AnswerLink = function AnswerLink(_ref) {
  var answer = _ref.answer,
      filetype = _ref.filetype;
  return /*#__PURE__*/_jsxs(StyledLink, {
    href: answer,
    alignItems: "center",
    display: "flex",
    target: "_blank",
    rel: "noopener noreferrer",
    "data-element": "StyledLink",
    "data-component": "AnswerLink",
    "data-source-file": "answer.tsx",
    children: [/*#__PURE__*/_jsx(Translation, {
      "data-element": "Translation",
      "data-component": "AnswerLink",
      "data-source-file": "answer.tsx",
      children: function children(t) {
        return t('View uploaded {{filetype}}', {
          filetype: filetype
        });
      }
    }), /*#__PURE__*/_jsx(OpenInNewIcon, {
      className: "openIcon",
      sx: {
        fontSize: '12px',
        ml: 1,
        color: function color(t) {
          return t.palette.neutral.main;
        }
      },
      "data-element": "OpenInNewIcon",
      "data-source-file": "answer.tsx"
    })]
  });
};

var VideoAnswer = function VideoAnswer(_ref2) {
  var answer = _ref2.answer;
  return /*#__PURE__*/_jsx("video", {
    src: answer,
    controls: true,
    width: "100%",
    "data-component": "VideoAnswer",
    "data-source-file": "answer.tsx"
  });
};

var LimitedHeightImage = styled('img')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: auto;\n  object-fit: contain;\n  max-height: 240px;\n"])));

var ImageAnswer = function ImageAnswer(_ref3) {
  var answer = _ref3.answer;
  return /*#__PURE__*/_jsx(LimitedHeightImage, {
    src: answer,
    alt: "Image Response",
    "data-element": "LimitedHeightImage",
    "data-component": "ImageAnswer",
    "data-source-file": "answer.tsx"
  });
};

var TextAnswer = function TextAnswer(_ref4) {
  var answer = _ref4.answer;
  return /*#__PURE__*/_jsx(Typography, {
    variant: "body1",
    sx: {
      mb: 2
    },
    "data-element": "Typography",
    "data-component": "TextAnswer",
    "data-source-file": "answer.tsx",
    children: answer
  });
};

var BrokenVideoAnswer = function BrokenVideoAnswer(_ref5) {
  var answer = _ref5.answer;
  return /*#__PURE__*/_jsx(AnswerLink, {
    filetype: "video",
    answer: answer,
    "data-element": "AnswerLink",
    "data-component": "BrokenVideoAnswer",
    "data-source-file": "answer.tsx"
  });
};

var RawVideoAnswer = function RawVideoAnswer(_ref6) {
  var answer = _ref6.answer;
  return pipe(extension(answer), O.chain(O.fromPredicate(function (x) {
    return x === 'mp4';
  })), O.match(function () {
    return /*#__PURE__*/_jsx(BrokenVideoAnswer, {
      answer: answer
    });
  }, function () {
    return /*#__PURE__*/_jsx(VideoAnswer, {
      answer: answer
    });
  }));
};

var FileAnswer = function FileAnswer(_ref7) {
  var answer = _ref7.answer;
  return /*#__PURE__*/_jsx(AnswerLink, {
    filetype: "file",
    answer: answer,
    "data-element": "AnswerLink",
    "data-component": "FileAnswer",
    "data-source-file": "answer.tsx"
  });
};

export var Answer = function Answer(_ref8) {
  var answer = _ref8.answer,
      answerType = _ref8.answerType;

  switch (answerType) {
    case 'Text':
      return /*#__PURE__*/_jsx(TextAnswer, {
        answer: answer
      });

    case 'ConvertedVideo':
      return /*#__PURE__*/_jsx(VideoAnswer, {
        answer: answer
      });

    case 'RawVideo':
      return /*#__PURE__*/_jsx(RawVideoAnswer, {
        answer: answer
      });

    case 'Image':
      return /*#__PURE__*/_jsx(ImageAnswer, {
        answer: answer
      });

    case 'File':
      return /*#__PURE__*/_jsx(FileAnswer, {
        answer: answer
      });

    case 'BrokenVideo':
      return /*#__PURE__*/_jsx(BrokenVideoAnswer, {
        answer: answer
      });

    default:
      return absurd(answerType);
  }
};